module.exports = __webpack_public_path__ + "static/media/20210401_193706_068_IMG_0005.a9076c62.jpg";